import { Experience } from "./experience";

export interface ExperienceDto extends Omit<Experience, "start" | "end"> {
	start: string;
	end?: string;
}

export function experienceFromDto(dto: ExperienceDto): Experience {
	return {
		...dto,
		countryCode: dto.countryCode ?? undefined,
		start: new Date(dto.start),
		end: dto.end ? new Date(dto.end) : undefined,
	};
}
